export const SURVEY_SCALES_PATH = "/surveys-editor/scales";
